var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 50,
    height: 50,
    viewBox: "0 0 172 172",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.96,13.76c-9.45834,0 -17.2,7.74166 -17.2,17.2v110.08c0,9.45834 7.74166,17.2 17.2,17.2h110.08c9.45834,0 17.2,-7.74166 17.2,-17.2v-110.08c0,-9.45834 -7.74166,-17.2 -17.2,-17.2zM30.96,20.64h110.08c5.73958,0 10.32,4.58042 10.32,10.32v110.08c0,5.73958 -4.58042,10.32 -10.32,10.32h-110.08c-5.73958,0 -10.32,-4.58042 -10.32,-10.32v-110.08c0,-5.73958 4.58042,-10.32 10.32,-10.32zM48.16,37.88031c-3.76756,0 -7.15789,1.12612 -9.66828,3.23844c-2.5104,2.11232 -4.0514,5.26797 -4.0514,8.64703c0,6.4231 5.57131,11.43047 12.65812,11.92578c0.00447,0.00225 0.00895,0.00449 0.01344,0.00672c0.33769,0.1151 0.6914,0.17632 1.04813,0.1814c7.81915,0 13.71969,-5.47716 13.71969,-12.1139c-0.00062,-0.06052 -0.00286,-0.12101 -0.00672,-0.18141c-0.35002,-6.53679 -6.17784,-11.70406 -13.71297,-11.70406zM48.16,44.67969c4.78927,0 6.68038,2.13884 6.88672,5.17344c-0.0418,2.94549 -1.86401,5.22719 -6.88672,5.22719c-4.7658,0 -6.92031,-2.44066 -6.92031,-5.31453c0,-1.43694 0.52433,-2.5198 1.62594,-3.44672c1.1016,-0.92692 2.86993,-1.63938 5.29437,-1.63938zM37.84,65.36c-1.89978,0.00019 -3.43981,1.54022 -3.44,3.44v65.36c0.00019,1.89978 1.54022,3.43981 3.44,3.44h20.64c1.89978,-0.00019 3.43981,-1.54022 3.44,-3.44v-20.1764v-45.1836c-0.00019,-1.89978 -1.54022,-3.43981 -3.44,-3.44zM68.8,65.36c-1.89978,0.00019 -3.43981,1.54022 -3.44,3.44v65.36c0.00019,1.89978 1.54022,3.43981 3.44,3.44h20.64c1.89978,-0.00019 3.43981,-1.54022 3.44,-3.44v-34.4c0,-2.85405 0.7788,-5.69308 2.15,-7.55187c1.3712,-1.8588 3.10104,-2.97433 6.38953,-2.91594c3.39096,0.05831 5.18606,1.21995 6.54406,3.0436c1.358,1.82364 2.1164,4.55755 2.1164,7.42422v34.4c0.00019,1.89978 1.54022,3.43981 3.44,3.44h20.64c1.89978,-0.00019 3.43981,-1.54022 3.44,-3.44v-36.93969c0,-10.18769 -3.01761,-18.25742 -8.19015,-23.71719c-5.17255,-5.45978 -12.36669,-8.14313 -19.97485,-8.14313c-7.23094,0 -12.73367,2.42482 -16.555,4.89797v-1.45797c-0.00019,-1.89978 -1.54022,-3.43981 -3.44,-3.44zM41.28,72.24h13.76v41.7436v16.7364h-13.76zM72.24,72.24h13.76v5.36828c0.00044,1.47922 0.94637,2.79257 2.34922,3.26171c1.40285,0.46914 2.94855,-0.01097 3.83874,-1.19234c0,0 5.40206,-7.43765 17.24703,-7.43765c6.03145,0 11.20362,2.00408 14.98281,5.99313c3.77919,3.98904 6.30219,10.13448 6.30219,18.98719v33.49969h-13.76v-30.96c0,-4.01333 -0.96159,-8.16275 -3.4736,-11.5361c-2.512,-3.37334 -6.7369,-5.72212 -11.94594,-5.81172c-5.23583,-0.09298 -9.529,2.30465 -12.04672,5.71766c-2.51772,3.413 -3.49375,7.60421 -3.49375,11.63015v30.96h-13.76z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.91c39c970c3c108ff3799a628d9c0e14.svg";
export { ForwardRef as ReactComponent };